import React from 'react';
import { Breadcrumbs, Typography } from '@material-ui/core';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import { breadcrumbTextRoot, breadcrumbsRootContainer, breadcrumbsSeparator } from './Subheader.styles';
import { getViewNameFromPath } from 'src/state/breadcrumbs/Breadcrumbs.utils';
import { CrumbPath } from 'src/state/breadcrumbs/Bread.slice';
import { first } from 'lodash';
import { Link } from 'react-router-dom';
import { TEAL_PRIMARY } from 'src/utils/Style/Theme';

interface LocalBreadcrumbsProps {
  activeCrumbPaths: CrumbPath[];
  onBreadcrumbClick: (crumb: CrumbPath) => void;
  onBreadcrumbReset: () => void;
}

export const LocalBreadcrumbs: React.FC<LocalBreadcrumbsProps> = ({
  activeCrumbPaths,
  onBreadcrumbClick,
  onBreadcrumbReset,
}: LocalBreadcrumbsProps) => {
  return (
    <React.Fragment>
      <Typography variant="caption" color="textSecondary" classes={{ root: breadcrumbTextRoot }}>
        Back to:
      </Typography>
      <Breadcrumbs
        maxItems={4}
        itemsAfterCollapse={2}
        itemsBeforeCollapse={1}
        separator={<NavigateNextIcon fontSize="small" />}
        classes={{
          root: breadcrumbsRootContainer,
          separator: breadcrumbsSeparator,
        }}
      >
        {activeCrumbPaths.map((crumb, idx, arr) => {
          const viewName = getViewNameFromPath(crumb.path);
          const isLast = idx === arr.length - 1;

          return !isLast ? (
            <Link style={{ color: TEAL_PRIMARY }} to={crumb.url} onClick={() => onBreadcrumbClick(crumb)}>
              {viewName}
            </Link>
          ) : (
            <Typography color="textSecondary" classes={{ root: breadcrumbTextRoot }}>
              {viewName}
            </Typography>
          );
        })}
      </Breadcrumbs>
      {/* <button onClick={() => onBreadcrumbReset()}>Reset All Crumb State</button> */}
    </React.Fragment>
  );
};
